import TableSortInputFilter from 'components/customComponents/Controls/tableSortInputFilter';
import CheckBox from 'components/customComponents/Experiment/ImagingSchedule/CheckBox';
import { KeyboardKeys } from 'constants/types';
import { useEventListener } from 'CustomHooks/useEventListener';
import { getNormalizedKeyboardKey } from 'keyboardShortcuts/utils';
import React, { useCallback } from 'react';

export const useTableColumns = (
  onChangeHeaderCheckbox,
  isSelectAllChecked,
  isReadOnly,
) => {
  const handleTableFilter = (filterable: boolean, filterTitle: string) => (event: any) =>
    (
      <TableSortInputFilter
        event={event}
        title={filterTitle}
        showSearchInput={filterable}
      />
    );

  const columns = [
    {
      Header: (
        <CheckBox
          isChecked={isSelectAllChecked}
          onChange={(e) => {
            onChangeHeaderCheckbox(e);
          }}
          disabled={isReadOnly}
        />
      ),
      id: 'addprotein-colums-header',
      accessor: 'mainCheck',
      width: '8%',
    },
    {
      Header: 'Type',
      id: 'addprotein-colums-type',
      accessor: 'type',
      width: '17%',
      Filter: handleTableFilter(false, 'Type'),
    },
    {
      Header: 'Name',
      id: 'addprotein-colums-name',
      accessor: 'name',
      width: '25%',
      Filter: handleTableFilter(false, 'Name'),
    },
    {
      Header: 'ID',
      id: 'addprotein-colums-id',
      accessor: 'id',
      width: '10%',
      Filter: handleTableFilter(false, 'ID'),
    },
    {
      Header: 'Lot',
      id: 'addprotein-colums-lot',
      accessor: 'lot',
      width: '10%',
      Filter: handleTableFilter(false, 'Lot'),
    },
    {
      Header: 'MW(kDa)',
      id: 'addprotein-colums-mw(kda)',
      accessor: 'mw',
      width: '10%',
      Filter: handleTableFilter(false, 'MW(kDa)'),
    },
    {
      Header: 'Conc.(mg/mL)',
      id: 'addprotein-colums-concmgml',
      accessor: 'conc1',
      width: '10%',
      Filter: handleTableFilter(false, 'Conc.(mg/mL)'),
    },
    {
      Header: 'Conc.(mM)',
      id: 'addprotein-colums-concmm',
      accessor: 'conc2',
      width: '10%',
      Filter: handleTableFilter(false, 'Conc.(mM)'),
    },
  ];

  return columns;
};

export const useProteinFormulationKeyboardHandler = (
  copyProteinIndredientsHandler?: () => void,
  pasteProteinIngredientsHandler?: () => void,
) => {
  const handleUserKeyPress = useCallback(
    async (e: KeyboardEvent) => {
      const activeElement = document.activeElement as HTMLElement | null;
      if (
        activeElement &&
        (activeElement.tagName === 'INPUT' ||
          activeElement.tagName === 'TEXTAREA' ||
          activeElement.isContentEditable)
      ) {
        return;
      }

      const key = getNormalizedKeyboardKey(e);
      const ctrlKey = e.ctrlKey || e.metaKey;

      if (ctrlKey && key === KeyboardKeys.c) {
        e.preventDefault();
        copyProteinIndredientsHandler?.();
      } else if (ctrlKey && key === KeyboardKeys.v) {
        e.preventDefault();
        pasteProteinIngredientsHandler?.();
      }
    },
    [copyProteinIndredientsHandler, pasteProteinIngredientsHandler],
  );

  useEventListener('keydown', handleUserKeyPress);
};
